'use strict';
(function($){
	/*
	 * Vetology.LionManager widget
	 *
	 * @description This is the main Vetology LionManager widget that needs a description right here
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.LionManager',
		{
			"options": {
			},
			/*
			 * Vetology.LionManager._init
			 *
			 * @description	Initializes the Vetology.LionManager
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._addEventHandlers();
			},
			/*
			 * Vetology.Vetology._addEventHandlers
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_addEventHandlers": function(){
				$("body").on("click", ".broadcastReboot", function(e){
					e.preventDefault();
					var el = $(this);
					var lid = el.data("id");
					var message = typeof lid === "undefined" ? "all lions" : "the lion with id" + lid;
					var url = typeof lid === "undefined" ? "" : "?lid=" + lid;
					$("body").Vetology("vetologyShowDialog", "ATTENTION:", "Are you sure you like to restart " + message + "?<br>This process once started can't be stopped", "error", function(){
						el.removeClass("broadcastReboot").removeClass("btn-primary").addClass("btn-warning").html("Broadcasting, please wait...");
						var source = new EventSource("/admin/lions/restart-all" + url, {withCredentials: true});
						$("body").Vetology("vetologyShowDialog", "ATTENTION:", "TASK RUNNING, DO NOT CLOSE YOUR BROWSER OR REFRESH THE PAGE<br><pre class=\"broadcast_log\"></pre>", "warning");
						var log = $(".broadcast_log");
						source.addEventListener("message" , function(e){
							var result = JSON.parse(e.data);
							if(e.data.search("TERMINATE") != -1){
								source.close();
								log.prepend("<p>Broadcast completed</p>");
							} else {
								log.prepend("<p>" + result.message + "</p>");
							}
							el.addClass("btn-success").removeClass("btn-warning").html("Broadcast completed");
						});
						source.addEventListener("error" , function(e){
							source.close();
						});
					}, 'Cancel', 'Yes, broadcast restart');
				});
				$('body').on('click', '.getFlashy', function(e){
					e.preventDefault();
					var el = $(this);
					$.ajax(
						{
							url		: '/getFlashy',
							method	: 'get',
							data	: {id:el.data('id')}
						}
					);
				});
				$('body').on('click', '.toggleLionStatus, .toggleCLionStatus, .toggleLionStatusC', function(e){
					var el = $(this);
					el
						.removeClass('btn-warning')
						.removeClass('btn-success')
						.addClass('bg-maroon')
						.html('Changing Status, please wait');
					var url = el.hasClass('toggleLionStatus') ? '/toggleLionStatus' : (el.hasClass('toggleCLionStatus')  ? '/toggleCLionStatus' : '/consultant/manage/lions/toggle');
					$.ajax(
						{
							url			: url,
							method		: 'get',
							data		: {id:el.data('id')},
							dataType	: 'JSON',
							success		: function(data){
								if(data.status == 0){
									el
									.removeClass('bg-maroon')
									.addClass('btn-warning')
									.html('Cases will not be sent, click to toggle');
								} else if(data.status == 1){
									el
									.removeClass('bg-maroon')
									.addClass('btn-success')
									.html('Cases will be sent, click to toggle');
								}
								if (data.user) {
                                    $("body").Vetology("vetologyShowDialog", "Incorrect Login", "You must be logged in as " + data.user + " to perform this action", "error");
                                }
							}
						}
					);
				});
				$('body').on('click', '.makeLionPrimary', function(e){
					var el = $(this);
					el.html("Making primary, please wait...");
					$.ajax(
						{
							url		: '/consultant/manage/lions/set-primary',
							method	: 'get',
							data	: {id:el.data('id')},
                            dataType: 'JSON',
                            success		: function(response){
                                if (response.success) {
                                    toastr.success(response.message, "Success", {
                                        onHidden: () => {
                                            $(".isFilter").change();
                                        }
                                    });
                                } else {
                                    toastr.error(response.message, "Error", {
                                        onHidden: () => {
                                            $(".isFilter").change();
                                        }
                                    });
                                }
 							}
						}
					);
				});
				$('body').on('click', '.toggleDICOMImport', function(e){
					e.preventDefault();
					var el = $(this);
					el
						.removeClass('btn-warning')
						.removeClass('btn-success')
						.addClass('bg-maroon')
						.html('Changing Status, please wait');
					$.ajax(
						{
							url			: "/admin/lions/manage/toggle-dicom-transfer",
							method		: 'post',
							data		: {
								"id": el.data('id')
							},
							dataType	: 'JSON',
							success		: function(data){
								if(data.status == 1){
									el.removeClass('bg-maroon').addClass('btn-success').html('Disable DICOM Import');
								} else {
									el.removeClass('bg-maroon').addClass('btn-warning').html('Enable DICOM Import');
								}
							}
						}
					);
				});
				this.addEventHandlersFinish();
			},

			"addEventHandlersFinish": function () {
				const o = this;
				$('body').on('click', '.sendEcho', function (e) {
					e.preventDefault();
					var el = $(this);
					el.addClass('sendingEcho').html('Echo sent, waiting for response...');
					$.ajax(
						{
							url: '/echoTest',
							method: 'get',
							data: { id: el.data('id') }
						}
					);
					setTimeout(
						function () {
							if (el.hasClass('sendingEcho')) {
								el.removeClass('sendingEcho').html('Echo failed');
							}
						},
						10000
					);
				});
				$("body").on('click', '.enable-disable-lion-btn', function (e) {
					e.preventDefault();
					const $el = $(e.currentTarget);
					let lionID = parseInt($el.closest('tr').children().first().text());
					const disable = $el.text() == 'Disable';
					const data = {
						LionID: lionID,
					};
					$.ajax({
						url: "/admin/lions/manage/enable-disable-lion",
						data: data,
						method: 'post',
						dataType: 'json'
					}
					).done(function (data, textStatus, jqXHR) {
						if (data.success) {
							$('body').Vetology('vetologyShowDialog', 'Lion status successfully changed', data.message, 'success');
							$el.text(disable ? 'Enable' : 'Disable');
							let disableText = $el.parent().html();
							if (disable) {
								disableText = disableText.replace("No", "Yes");
								$el.text('Enable');
							} else {
								disableText = disableText.replace("Yes", "No");
								$el.text('Disable');
							}
							$el.parent().html(disableText);
						}
					}).fail(function (jqXHR, textStatus, errorThrown) {
						$('body').Vetology('vetologyShowDialog', "Error changing Lion Status", data.message, 'error');
					});
				});

				if (document.querySelector('.lion-error-threshold')) {
					o.addEventHandlersFinishErrorThreshold();
				}
				
			},

			addEventHandlersFinishErrorThreshold: function() {
				const tbody = document.querySelector('tbody.targetHtml');
				if(tbody) {
					tbody.addEventListener('blur', function (event) {
						if (event.target.classList.contains('lion-error-threshold')) {
							const formData = new FormData();
							formData.append('errorThreshold', event.target.value);
							formData.append('lionID', event.target.closest('tr').firstElementChild.textContent);
							fetch("/admin/lions/manage/update-error-threshold", {
								method: 'post',

								body: formData
							}).then((response) => {
								if (!response.ok) {
									$('body').Vetology('vetologyShowDialog', 'Error:', 'Could not update your lion at this time.', 'error');
								} else {
									return response.json();
								}
							}).then(data => {
								if (data.success) {
									if (data.updated) {
										$('body').Vetology('vetologyShowDialog', 'Success:', 'The error threshold has been successfully updated.', 'success');
									}
								}
							});
						}
					}, true);
				}
			}
		}
	);
})(jQuery);

